/**
 * Đọc số tiền (đồng) ra chữ tiếng Việt, ví dụ: 133400 → "Một trăm ba mươi ba nghìn bốn trăm đồng"
 */
const CH = ['không', 'một', 'hai', 'ba', 'bốn', 'năm', 'sáu', 'bảy', 'tám', 'chín'];
const DV = ['', 'nghìn', 'triệu', 'tỷ'];

function readThreeDigits(n: number): string {
  if (n === 0) return '';
  const tr = Math.floor(n / 100);
  const du = n % 100;
  const ch = Math.floor(du / 10);
  const dv = du % 10;
  let s = '';
  if (tr > 0) s += `${CH[tr]} trăm `;
  if (ch === 0) {
    if (dv > 0) {
      if (tr > 0) s += 'linh ';
      s += CH[dv];
    }
  } else if (ch === 1) {
    s += 'mười ';
    if (dv > 0) s += dv === 5 ? 'lăm' : CH[dv];
  } else {
    s += `${CH[ch]} mươi `;
    if (dv === 1) s += 'mốt';
    else if (dv === 5) s += 'lăm';
    else if (dv > 0) s += CH[dv];
  }
  return s.trim();
}

export function readVietnameseMoney(n: number): string {
  if (!Number.isFinite(n) || n === 0) return 'Không đồng';
  const neg = n < 0;
  let x = Math.floor(Math.abs(n));
  if (x === 0) return 'Không đồng';

  const parts: string[] = [];
  let i = 0;
  while (x > 0) {
    const g = x % 1000;
    if (g > 0) {
      const read = readThreeDigits(g);
      const unit = DV[i] ? ` ${DV[i]}` : '';
      parts.unshift(read + unit);
    }
    x = Math.floor(x / 1000);
    i += 1;
  }

  let out = parts.join(' ').replace(/\s+/g, ' ').trim();
  if (neg) out = 'Âm ' + out;
  const cap = out.charAt(0).toUpperCase() + out.slice(1);
  return `${cap} đồng`;
}
